import { useState, useCallback } from 'react';
import { apiService } from '../services/api';
import type { AdminUserDto } from '../services/api';
import { getApiErrorMessage } from '../types/api-errors';

export const useAdminUsers = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [users, setUsers] = useState<AdminUserDto[]>([]);
    const [totalCount, setTotalCount] = useState(0);

    const fetchUsers = useCallback(async (params?: { search?: string; role?: string; page?: number; pageSize?: number }) => {
        setLoading(true);
        setError(null);
        try {
            const res = await apiService.getAdminUsers(params);
            setUsers(res.users);
            setTotalCount(res.totalCount);
            return res;
        } catch (err: unknown) {
            const msg = getApiErrorMessage(err, 'Unable to load users.');
            setError(msg);
            throw new Error(msg);
        } finally {
            setLoading(false);
        }
    }, []);

    // AB#2112 — explicit target state. The confirmation dialog owns the
    // pending/error UI, so the original error is rethrown (it carries the
    // server's code) and the list-level loading/error state is left alone.
    const toggleStatus = useCallback(
        (userId: number, isActive: boolean) => apiService.toggleAdminUserStatus(userId, isActive),
        [],
    );

    return { loading, error, users, totalCount, fetchUsers, toggleStatus };
};
